import env from "env";

const {
  b2bPortalRole,
  paymentOptsRole,
  b2bPortalAdminRole,
  b2bPortalApproverRole,
  b2bPortalBUApproverRole,
  configurationMinUsers,
  configurationMaxUsers,
} = env.app;

export const Roles = {
  Member: "Member",
  BusinessOwner: b2bPortalRole,
  PaymentOps: paymentOptsRole,
  BusinessAdmin: b2bPortalAdminRole,
  BusinessApprover: b2bPortalApproverRole,
  BUApprover: b2bPortalBUApproverRole,
  BUChecker: b2bPortalApproverRole,
  BUMaker: b2bPortalRole,
};

export const ConfigMinMaxUser = {
  MinUsers: parseInt(configurationMinUsers),
  MaxUsers: parseInt(configurationMaxUsers),
};

export const RegisterUserErrorMessages = {
  Checker: `You have reached the limit of ${ConfigMinMaxUser.MaxUsers} Business Checkers, including both Activated and Activation Pending users. Please block an existing Business Checker before inviting a new one`,
  Maker: `You have reached the limit of ${ConfigMinMaxUser.MaxUsers} Business Maker, including both Activated and Activation Pending users. Please block an existing Business Maker before inviting a new one.`,
  Approver: `You have reached the limit of ${ConfigMinMaxUser.MaxUsers} Business Approver, including both Activated and Activation Pending users. Please block an existing Business Approver before inviting a new one`,
};

export const BlockUserErrorMessages = {
  Checker: `The number of users in the Checker category needs to be between ${ConfigMinMaxUser.MinUsers} and ${ConfigMinMaxUser.MaxUsers}. Please add another Checker if you are below the minimum number of Checkers.`,
  Maker: `The number of users in the Maker category needs to be between ${ConfigMinMaxUser.MinUsers} and ${ConfigMinMaxUser.MaxUsers}. Please add another Maker if you are below the minimum number of Makers.`,
  Approver: `The number of users in the Approver category needs to be between ${ConfigMinMaxUser.MinUsers} and ${ConfigMinMaxUser.MaxUsers}. Please add another Approver if you are below the minimum number of Approvers.`,
};

export enum PaymentMethod {
  NORMAL_PAY = "Prepaid",
  EARLY_PAY = "Postpaid",
}

export enum DataLoaderDataSets {
  DAKKO_PAYSLIP_DS = "DAKKO_PAYSLIP_DS",
  PAYROLL_DS = "PAYROLL_DS",
}

export enum DataLoaderUploadStatuses {
  UPLOADED = "UPLOADED",
  PROCESSING = "PROCESSING",
  PARTIAL = "PARTIAL",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum ApprovalTaskStatues {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  CHECKER_APPROVED = "CHECKER_APPROVED",
  APPROVER_APPROVED = "APPROVER_APPROVED",
  CHECKER_REJECTED = "CHECKER_REJECTED",
  APPROVER_DISAPPROVED = "APPROVER_DISAPPROVED",
  PAYMENT_OPS_DECLINED = "PAYMENT_OPS_DECLINED",
  PAYMENT_OPS_PROCESSED = "APPROVED",
  SUBMITTED = "PENDING",
}

export enum ApprovalAction {
  PROCESSED = "processed",
  DECLINED = "declined",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;

export enum AntiVirusStatuses {
  SCANNING = "SCANNING",
  SAFE = "SAFE",
  INFECTED = "INFECTED",
}

export const RoleOptions = [
  {
    value: Roles.PaymentOps,
    label: "PaymentOps",
    data: { title: "PaymentOps" },
  },
  {
    value: Roles.BusinessAdmin,
    label: "Enterprise User",
    data: { title: "Business Admin" },
  },
  {
    value: Roles.BusinessApprover,
    label: "Enterprise User",
    data: { title: "Business Checker" },
  },
  {
    value: Roles.BusinessOwner,
    label: "Enterprise User",
    data: { title: "Business Maker" },
  },
  {
    value: Roles.BUApprover,
    label: "Business Approver",
    data: { title: "Business Approver" },
  },
];

export const paymentMethodOptions = [
  { value: PaymentMethod.NORMAL_PAY, label: "Prepaid" },
  { value: PaymentMethod.EARLY_PAY, label: "Postpaid" },
];

export const filterUserRoleOptions = [
  {
    value: [Roles.BUChecker, Roles.BUMaker, Roles.BUApprover].join(","),
    label: "User Role",
  },
  { value: Roles.BUMaker, label: "Business Maker" },
  { value: Roles.BUChecker, label: "Business Checker" },
  { value: Roles.BUApprover, label: "Business Approver" },
];

export const EMPTY_FIELD = "N/A";
